import BankAccountsList from './BankAccountsList';

export default BankAccountsList;
